module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"all":"Mehr sehen","title":"Häufig gestellte Fragen"},"en":{"all":"See more","title":"Frequently Asked Questions"},"it":{"all":"","title":""},"lt":{"all":"Daugiau","title":"D.U.K"},"pl":{"all":"Pozostałe pytania","title":"Najczęściej zadawane pytania"}}')
  delete Component.options._Ctor
}
